/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { AggregationResultService } from './services/aggregation-result.service';
import { AttachmentService } from './services/attachment.service';
import { AviUsageDataService } from './services/avi-usage-data.service';
import { ClientBillingAgreementService } from './services/client-billing-agreement.service';
import { ClientBillingBackupFileService } from './services/client-billing-backup-file.service';
import { ClientBillingBackupFileConfigurationService } from './services/client-billing-backup-file-configuration.service';
import { ClientBillingIgnoreProductService } from './services/client-billing-ignore-product.service';
import { ClientBillingInvoiceService } from './services/client-billing-invoice.service';
import { ClientInfoService } from './services/client-info.service';
import { ClientMappingService } from './services/client-mapping.service';
import { ClientStatusTableService } from './services/client-status-table.service';
import { CustomProductMappingService } from './services/custom-product-mapping.service';
import { DashboardService } from './services/dashboard.service';
import { ExtractClientBillingUsageService } from './services/extract-client-billing-usage.service';
import { FilePortalService } from './services/file-portal.service';
import { GTVService } from './services/gtv.service';
import { KeyValueService } from './services/key-value.service';
import { ManualUsageEventService } from './services/manual-usage-event.service';
import { PersonaService } from './services/persona.service';
import { SalesForceBillingRegistryService } from './services/sales-force-billing-registry.service';
import { SFClientRegistryService } from './services/sfclient-registry.service';
import { TractService } from './services/tract.service';
import { TractChildRegistryService } from './services/tract-child-registry.service';
import { TractParentRegistryService } from './services/tract-parent-registry.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    AggregationResultService,
    AttachmentService,
    AviUsageDataService,
    ClientBillingAgreementService,
    ClientBillingBackupFileService,
    ClientBillingBackupFileConfigurationService,
    ClientBillingIgnoreProductService,
    ClientBillingInvoiceService,
    ClientInfoService,
    ClientMappingService,
    ClientStatusTableService,
    CustomProductMappingService,
    DashboardService,
    ExtractClientBillingUsageService,
    FilePortalService,
    GTVService,
    KeyValueService,
    ManualUsageEventService,
    PersonaService,
    SalesForceBillingRegistryService,
    SFClientRegistryService,
    TractService,
    TractChildRegistryService,
    TractParentRegistryService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
